import { useEffect } from 'react';
import { Text } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import FullPageLoader from '@components/general/loader/full-page-loader.component';
import { useUserStore } from '@store/app.store';
import { useStyledToast } from '@util/hooks';

export default function OTPRedirectPage() {
  const [query] = useSearchParams();
  const params = {
    personId: query.get('personId'),
    passcode: query.get('passcode'),
    paymentId: query.get('paymentId')
  };
  const { personId, passcode, paymentId } = params;
  const authenticateWithOTP = useUserStore((state) => state.authenticateWithOTP);
  const navigate = useNavigate();
  const toast = useStyledToast();

  const invalidOTPHandler = () => {
    toast({
      title: 'Invalid Login Link',
      description: 'Please provide a valid login link.',
      status: 'error'
    });
    return navigate('/login');
  };

  useEffect(() => {
    async function handleRedeemOTP() {
      try {
        await authenticateWithOTP(personId, passcode, paymentId);
        navigate('/');
      } catch (e) {
        Sentry.withScope((scope) => {
          scope.setTag('error_type', 'otp_auth_error');
          scope.setExtra('error_message', 'Error authenticating OTP');
          Sentry.captureException(e);
        });
        invalidOTPHandler();
      }
    }

    if (!passcode || !personId) {
      invalidOTPHandler();
    } else {
      handleRedeemOTP();
    }
  }, [passcode, personId]);

  return (
    <FullPageLoader>
      <Text>Verifying login...</Text>
    </FullPageLoader>
  );
}
